import { Injectable } from '@angular/core';
import { ApiHttpService } from '../../../shared/services/api_http.service';
import { Observable } from 'rxjs';
import { ShopifyErrors } from './shopify.errors';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';

@Injectable()
export class ShopifyService {

  private isShopify2$: Observable<any>;

  constructor(private http: ApiHttpService) {}

  checkAutoInstallPreconditions(): Observable<any> {
    return this.http.get('apps/:app_key/auto_install/check_preconditions').pipe(
      map((response: any) =>
        new ShopifyErrors(response.errors).getErrors()
      )
    );
  }

  autoInstall(params): Observable<any> {
    return this.http.post('apps/:app_key/auto_install/install', params);
  };

  isShopify2(): Observable<any> {
    if (this.isShopify2$) {
      return this.isShopify2$;
    }
    this.isShopify2$ = this.http.get('apps/:app_key/auto_install/is_shopify_2').pipe(
      catchError(() => of({response: false}))
    );
    return this.isShopify2$;
  }

  shopDeeplink(): Observable<any> {
    return this.http.get('apps/:app_key/auto_install/shop_deeplink');
  }

  integrateAppKey(params): Observable<any> {
    return this.http.post('apps/:app_key/auto_install/integrate_app_key', params);
  }
}
